import { useTranslation } from 'react-i18next';

import { Box, Text } from '@bonusly/design-system';

interface BizySourceDetailsProps {
	sourceDetails: string;
	caveats: string;
}

/**
 * Renders the Data Agent's SourceDetails node — the collapsible "How I got
 * this" provenance panel that trails a data answer: what was queried
 * (sourceDetails) and the limitations / assumptions (caveats). Mirrors the
 * native <details> disclosure the agent previously emitted as trailing
 * markdown, now driven by a typed node. Collapsed by default so it doesn't
 * compete with the answer.
 */
export function BizySourceDetails({ sourceDetails, caveats }: BizySourceDetailsProps) {
	const { t } = useTranslation('admin_bizy');

	return (
		<Box as="details" mb={4} fontSize="sm" color="text.muted" data-testid="bizy-source-details">
			<Box as="summary" cursor="pointer" fontSize="sm" fontWeight="semibold" color="text.default">
				{t('sourceDetails.heading')}
			</Box>
			<Box mt={2}>
				<Text fontSize="sm" fontWeight="semibold" color="text.default">
					{t('sourceDetails.sourceDetailsLabel')}
				</Text>
				<Text fontSize="sm" mb={2}>
					{sourceDetails || t('sourceDetails.noSourceDetails')}
				</Text>
				<Text fontSize="sm" fontWeight="semibold" color="text.default">
					{t('sourceDetails.caveatsLabel')}
				</Text>
				<Text fontSize="sm">{caveats || t('sourceDetails.noCaveats')}</Text>
			</Box>
		</Box>
	);
}
